import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import PasswordField from "./PasswordField";
import apiClient from "./utils/apiClient";

const ResetPasswordDialog = () => {
  const { resetToken } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleResetPassword = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      await apiClient.post("/reset-password", {
        resetToken,
        newPassword: password,
      });
      setSuccessMessage("Password reset successfully. Redirecting to login...");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setErrorMessage("Failed to reset password. The link may be expired or invalid.");
    }
  };

  return (
    <Dialog open={true}>
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        {successMessage && <Alert severity="success">{successMessage}</Alert>}
        <PasswordField
          value={password}
          onChange={setPassword}
          confirmValue={confirmPassword}
          confirmOnChange={setConfirmPassword}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => navigate("/login")}>Cancel</Button>
        <Button onClick={handleResetPassword} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordDialog;
